/**
 * @copyright 2023 Honda Motor Co., Ltd. All rights reserved.
 */

import { FC, useMemo } from "react";
import { AwvInfo } from "client";
import { Multiple, MultipleProps } from "./Multiple";
import { getJobCardStatus } from "./JobCard";
import { useUserContext } from "context/UserContext";

// AWV Card when data not exist.
const emptyAwvInfo: AwvInfo = {
  frameTypeAndNumber: "--",
  nameId: "--",
  condition: undefined,
};

export const MultipleWrapper: FC<MultipleProps> = (props) => {
  const { roleName } = useUserContext();
  const merge = props.awvInfos || [emptyAwvInfo];

  const copyAwvInfos = [...merge];
  // order by nameId
  copyAwvInfos.sort((a, b) => ((a.nameId ?? "") <= (b.nameId ?? "") ? -1 : 1));
  // If awvInfos is less than 3, it should be 3
  for (let i = copyAwvInfos.length ?? 0; i < 3; i++) {
    const emptyAwvInfoNum = {
      ...emptyAwvInfo,
      frameTypeAndNumber: `empty-${i}`,
    };
    copyAwvInfos.push({ ...emptyAwvInfoNum });
  }
  const excludeHiddenTask = useMemo(() => {
    if (props.tasks) {
      return props.tasks.filter(
        (task) =>
          getJobCardStatus(
            task.jobSetStatus,
            task.taskStatus,
            task.endDatetime,
            task.taskKind,
            roleName
          ) !== "hidden"
      );
    }
  }, [props.tasks, roleName]);

  return (
    <Multiple
      awvInfos={copyAwvInfos}
      tasks={excludeHiddenTask}
      date={props.date}
      setDate={props.setDate}
    />
  );
};
